var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 19.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#474747;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.5,3.1H3.2c.2,1.2,1.3,2.1,2.6,2.1s2.3-.9,2.6-2.1h14.2c.3,0,.5-.2,.5-.5s-.2-.5-.5-.5H8.3c-.2-1.2-1.3-2.1-2.6-2.1S3.4,.9,3.2,2.1H.5c-.3,0-.5,.2-.5,.5s.2,.5,.5,.5ZM5.8,1c.9,0,1.6,.7,1.6,1.6s-.7,1.6-1.6,1.6-1.6-.7-1.6-1.6,.7-1.6,1.6-1.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.5,9.4h-1.6c-.2-1.2-1.3-2.1-2.6-2.1s-2.3,.9-2.6,2.1H.5C.2,9.4,0,9.6,0,9.9s.2,.5,.5,.5H15.7c.2,1.2,1.3,2.1,2.6,2.1s2.3-.9,2.6-2.1h1.6c.3,0,.5-.2,.5-.5s-.2-.5-.5-.5Zm-4.2,2.1c-.9,0-1.6-.7-1.6-1.6s.7-1.6,1.6-1.6,1.6,.7,1.6,1.6-.7,1.6-1.6,1.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.5,16.7H14.1c-.2-1.2-1.3-2.1-2.6-2.1s-2.3,.9-2.6,2.1H.5C.2,16.7,0,17,0,17.2s.2,.5,.5,.5H8.9c.2,1.2,1.3,2.1,2.6,2.1s2.3-.9,2.6-2.1h8.4c.3,0,.5-.2,.5-.5s-.2-.5-.5-.5Zm-11,2.1c-.9,0-1.6-.7-1.6-1.6s.7-1.6,1.6-1.6,1.6,.7,1.6,1.6-.7,1.6-1.6,1.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.db84386894e9f9e4e2f9a78d6ebbfc5c.svg";
export { ForwardRef as ReactComponent };